module.exports = __webpack_public_path__ + "static/media/cases_anuncios_01b.4558ff0b.jpg";